import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.title}`,
    id: _ctx.viewName,
    "width-class": "w-100 w-md-600px py-0",
    showDialog: _ctx.showDialog,
    onModalClose: _ctx.close
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _toDisplayString(_ctx.t("common.close")), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_LineChart, {
        dateFilterValue: _ctx.dateFilterValue,
        reference: _ctx.reference,
        column: _ctx.column,
        webId: _ctx.data.webId,
        userSiteId: _ctx.userSiteId,
        height: "200"
      }, null, 8, ["dateFilterValue", "reference", "column", "webId", "userSiteId"])
    ]),
    _: 1
  }, 8, ["title", "id", "showDialog", "onModalClose"]))
}